export default "__VITE_ASSET__CB$gpyR0__";